<p class="text text--align-center text--detail spacing spacing--padding-large">&copy; {current_year} Bernhard Esperester. All Rights Reserved.</p>

<script>
    import moment from 'moment'

    export default {
        components: {
        },
        computed: {
            current_year: ({ moment }) => {
                return moment.format('YYYY')
            },
        },
        data() {
            return {
                moment: moment()
            }
        }
    }
</script>